module.exports = __webpack_public_path__ + "img/ic_empty_img_draft_box.e7e0c666.png";